<script setup lang="ts">
import type { RentalPeriod } from '@/types/models/DeviceRentalPeriods'
import {
    DividerItem,
    StackLayout,
    TypographyItem,
    TypographyWithPrefix
} from '@rfc/rfc-components-library'
import { type DateProviderType, EProviders } from '@rfc/rfc-components-library/types'
import moment from 'moment'
import { inject } from 'vue'

const { DATETIME_FORMAT } = inject<DateProviderType>(EProviders.DATE, {})

type Props = {
    periods: RentalPeriod[]
}
defineProps<Props>()
</script>

<template>
    <StackLayout direction="column">
        <TypographyItem :label="$t('device.rental.unavailabilities')" />
        <StackLayout direction="column" v-for="(unavailablePeriod, index) in periods" :key="index">
            <TypographyWithPrefix
                :prefix="$t('date.start')"
                :label="moment(unavailablePeriod.start).format(DATETIME_FORMAT)" />
            <TypographyWithPrefix
                :prefix="$t('date.end')"
                :label="moment(unavailablePeriod.end).format(DATETIME_FORMAT)" />
            <TypographyItem :label="unavailablePeriod.reason" />
            <DividerItem v-if="index + 1 !== periods.length" />
        </StackLayout>
    </StackLayout>
</template>
